

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { setResultModalData, showNestedModal } from "../modal/modalSlice";
import { updateYuklemedeListForShipmentOperation } from "../loadList/loadListSlice";
import { toast } from "react-toastify";
import { toastApiError } from "../../helper/api/toastApiError";

const mapCollection = (collection, mapper) => {
  if (Array.isArray(collection)) return collection.map(mapper)
  if (Array.isArray(collection?.$values)) {
    return { ...collection, $values: collection.$values.map(mapper) }
  }
  return collection
}

const initialState = {

    isLoadingManageShipmentOperation: false,

    shipmentDetailsForManage: null,
    isLoadingShipmentDetailsForManage: false,
    shipmentDetailsForManageError: null,
    isLoadingForceReleaseVehicleClaim: false,

    operationRoute: null,

    //! bu işlem yapıılnca başka sayfaya yönlendirme için
    isOperationResultsSuccess: false,

    redirectPath: "",


    isLoadingAddShipmentDocument: false,


};

export const getShipmentDetailsForManage = createAsyncThunk(
  "shipmentOperation/getShipmentDetailsForManage",
  async (shipmentOrId, thunkApi) => {
    const shipmentId = typeof shipmentOrId === "object"
      ? shipmentOrId?.id
      : shipmentOrId;

    if (!shipmentId) {
      return thunkApi.rejectWithValue({ message: "Sevkiyat kimliği bulunamadı." });
    }

    try {
      // GetShipmentById, Response<T> zarfı olmadan DTO'yu doğrudan döndürür.
      const { data } = await axiosInstance.get(
        `/Shipment/GetShipmentById?id=${encodeURIComponent(shipmentId)}`
      );
      return data;
    } catch (error) {
      const message = toastApiError(error, "Sevkiyat detayı alınamadı.");
      return thunkApi.rejectWithValue({ message, status: error?.response?.status ?? null });
    }
  }
);

export const forceReleaseVehicleClaim = createAsyncThunk(
  "shipmentOperation/forceReleaseVehicleClaim",
  async ({ shipmentId, reason }, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        "/Shipment/ForceReleaseVehicleClaim",
        {
          shipmentId: Number(shipmentId),
          reason: reason?.trim() || null,
        }
      );

      await thunkApi.dispatch(getShipmentDetailsForManage(shipmentId));
      toast.success("Sürücü taşıma setinden çıkarıldı. Set başka bir uygun sürücü tarafından teslim alınabilir.");
      return data;
    } catch (error) {
      // 404 normal bir yarış durumu olabilir; her durumda sunucu durumunu tekrar oku.
      if (error?.response?.status === 404) {
        await thunkApi.dispatch(getShipmentDetailsForManage(shipmentId));
      }

      const message = toastApiError(error, "Sürücü taşıma setinden çıkarılamadı.");
      return thunkApi.rejectWithValue({ message, status: error?.response?.status ?? null });
    }
  }
);
    
export const manageShipmentOperation = createAsyncThunk("shipmentOperation/manageShipmentOperation",async (shipmentOperation, thunkApi) => {
  try {
    
    const { data } = await axiosInstance.post(`/shipment/ManageShipmentOperation`, shipmentOperation);
let redirectPath = ""
if(data.statusCode === 200){
      if(data?.data?.stateOfShipment === 0){
        redirectPath = "/yuklemede"

        const item = thunkApi.getState().loadList.yuklemedeList.find(item => item?.id === shipmentOperation?.id)
        if (item) {
          const updatedItem = {
            ...item,
            routePoints: mapCollection(item.routePoints, (routePoint) =>
              routePoint.id === shipmentOperation?.routePointId
                ? { ...routePoint, stateOfRoutePoint: data?.data?.stateOfRoutePoint }
                : routePoint
            ),
          }
          thunkApi.dispatch(updateYuklemedeListForShipmentOperation(updatedItem))
        }

      }

      else if(data?.data?.stateOfShipment === 1){
        redirectPath = "/seferde"
      }

      else if(data?.data?.stateOfShipment === 2){
        redirectPath = "/bosaltmada"
      }

      else if(data?.data?.stateOfShipment === 3){
        redirectPath = "/tamamlanan-seferler"
      }

      thunkApi.dispatch(showNestedModal("result"))
      thunkApi.dispatch(setResultModalData({msg: "İşlem başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
      thunkApi.dispatch(getShipmentDetailsForManage(shipmentOperation.id))
    }
    else{
      const message = toastApiError(
        data,
        "Bir hata meydana geldi, lütfen daha sonra tekrar deneyin."
      )
      thunkApi.dispatch(showNestedModal("result"))
      thunkApi.dispatch(setResultModalData({msg: message, resultType: "error", btnText1: "Harika"}))
    }
    return  data.statusCode === 200 ? {...shipmentOperation, redirectPath, companyName: data?.data?.companyName}: null
  } catch (error) {
    const message = toastApiError(error)
    return thunkApi.rejectWithValue({ message, status: error?.response?.status ?? null });
  }
});




export const addShipmentDocument = createAsyncThunk("shipmentOperation/addShipmentDocument",async (docData, thunkApi) => {
  try {
    
        const file = new FormData();
        file.append("id", docData.id);
        file.append("routePointId", docData.routePointId);
        file.append("file", docData.file);

        const { data } = await axiosInstance.post(`/shipment/AddShipmentDocument`, file);

        if(data.statusCode === 200){
          thunkApi.dispatch(showNestedModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Sevk irsaliyesi sisteme başarıyla yüklendi.", resultType: "success", btnText1: "Harika"}))
        }
        else{
          thunkApi.dispatch(showNestedModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Sevk irsaliyesi yüklenirken bir hata meydana geldi, lütfen daha sonra tekrar deneyin.", resultType: "error", btnText1: "Harika"}))
        }
    return {imageName: data?.data?.imageName, ...docData};
  } catch (error) {
    const message = toastApiError(error, "Sevk irsaliyesi yüklenemedi.")
    return thunkApi.rejectWithValue({ message, status: error?.response?.status ?? null });
  }
});


 

const shipmentOperationSlice = createSlice({
  name: "shipmentOperation",
  initialState,
  reducers: {

    resetShipmentDetailsForManage: (state) => {
        state.shipmentDetailsForManage = null
        state.shipmentDetailsForManageError = null
    },

    setOperationRoute: (state,action) => {
        state.operationRoute = action.payload
    },

    //! bu her ShipmentOperationModal modalına girildiğinde önceki işlemden kalanları resrtlemek için (özellikle opration resultlarını)
    resetRedirectPath: (state,action) => {
      state.redirectPath = ""
      state.isOperationResultsSuccess = false
    }

  },
  extraReducers: (builder) => {
    builder

        .addCase(getShipmentDetailsForManage.pending, (state) => {
          state.isLoadingShipmentDetailsForManage = true
          state.shipmentDetailsForManageError = null
        })
        .addCase(getShipmentDetailsForManage.fulfilled, (state, action) => {
          state.isLoadingShipmentDetailsForManage = false
          state.shipmentDetailsForManage = action.payload
        })
        .addCase(getShipmentDetailsForManage.rejected, (state, action) => {
          state.isLoadingShipmentDetailsForManage = false
          state.shipmentDetailsForManageError = action.payload?.message || "Sevkiyat detayı alınamadı."
        })

        .addCase(forceReleaseVehicleClaim.pending, (state) => {
          state.isLoadingForceReleaseVehicleClaim = true
        })
        .addCase(forceReleaseVehicleClaim.fulfilled, (state) => {
          state.isLoadingForceReleaseVehicleClaim = false
        })
        .addCase(forceReleaseVehicleClaim.rejected, (state) => {
          state.isLoadingForceReleaseVehicleClaim = false
        })

        //! manageShipmentOperation
        .addCase(manageShipmentOperation.pending, (state)=> {
            state.isLoadingManageShipmentOperation = true
        })

        .addCase(manageShipmentOperation.fulfilled, (state, action)=> {
            state.isLoadingManageShipmentOperation = false
            
            if(action.payload){
              state.isOperationResultsSuccess = true
              state.redirectPath = action.payload.redirectPath
              state.shipmentDetailsForManage = {
                ...state.shipmentDetailsForManage,
                routePoints: mapCollection(
                  state.shipmentDetailsForManage?.routePoints,
                  (item) => item.id === action.payload.routePointId
                    ? {
                        ...item,
                        stateOfRoutePoint: action.payload.stateOfRoutePoint,
                        updatedByCompany: action.payload?.companyName,
                      }
                    : item
                ),
              }
            }
        })

        .addCase(manageShipmentOperation.rejected, (state, action)=> {
            state.isLoadingManageShipmentOperation = false
        })



        //! addShipmentDocument
        .addCase(addShipmentDocument.pending, (state)=> {
          state.isLoadingAddShipmentDocument = true

        })

        .addCase(addShipmentDocument.fulfilled, (state, action)=> {
          state.isLoadingAddShipmentDocument = false

          //! tüm liste için de yapman lazım gibi
              state.shipmentDetailsForManage = {
                ...state.shipmentDetailsForManage,
                routePoints: mapCollection(
                  state.shipmentDetailsForManage?.routePoints,
                  (item) => item.id === action.payload.routePointId
                    ? { ...item, documentOfRoutePoint: action.payload.imageName }
                    : item
                ),
              }
          
          
        })

        .addCase(addShipmentDocument.rejected, (state, action)=> {
          state.isLoadingAddShipmentDocument = false

        })

  },
});


export const {  
resetShipmentDetailsForManage,
setOperationRoute,
resetRedirectPath
} = shipmentOperationSlice.actions;
export default shipmentOperationSlice.reducer;


